import moment from 'moment-timezone';

const filterRelationsWithLogins = relations => relations.filter(rel => !rel.loginId);
const childrenToRelations = children => children.map(child => child.relations).flatMap(a => a);

export const relationsFromChildren = children =>
    filterRelationsWithLogins(childrenToRelations(currentAndFutureChildren(children)));
export const relationIdsFromChildren = children => relationsFromChildren(children).map(rel => rel.relationId);
export const relationIdsWithChildIds = children =>
    currentAndFutureChildren(children)
        .map(child => child.relations.map(rel => [rel.relationId, child.childId]))
        .flatMap(a => a);

export const currentAndFutureChildren = children => {
    const today = moment();
    return children.filter(
        child =>
            ((!child.endDate || (child.endDate && moment(child.endDate).isSameOrAfter(today))) &&
                child.startDate &&
                moment(child.startDate).isSameOrBefore(today)) ||
            (child.startDate && moment(child.startDate).isAfter(today)),
    );
};
